import React, { Suspense, lazy, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import * as Loading from "@repoflow/components/loading";

import { Filter, DEFAULT_RANGE, buildFilter, rangeLabel } from "components/statistics/filter";

// recharts and its d3 tree are ~100KB gzipped. Lazily loaded so /domain — the
// section this app is actually worked in — never pays for them, the same way
// bucketws' dashboard does it.
const OrganizationCharts = lazy(() => import("../charts"));

export const Sidebar = () => null;

export const Indice = () => null;

// Everything about this ORGANIZATION that is a number, on one screen: what the
// domains it owns did over the selected window.
//
// EVERYTHING BELOW THE FILTER IS A WINDOW, and four of the five measures in it
// are deltas — +1 as a domain, organization, user or key appears and -1 as it
// goes. So nothing here is a holding: "how many users do I have" is the sum over
// all of history, and datum clamps a capture window to 31 days. The fifth,
// sign-ins, only ever adds, so its total is complete and is the one figure on
// the screen that means what it looks like.
//
// There is deliberately no limits panel, which is the one thing bucketws'
// dashboard has that this does not: no limit is declared against the auth
// statistics point — nothing caps how many users an organization may have — so
// there is no absolute to show and no honest source for one.
//
// There is also no capture listing. A row-level table across an organization is
// a second billed Timestream query answering a question this screen is not
// asking, and datum's own point screens answer it for whoever owns the point.
// See docs/auth-statistics.md.
export const Content = () => {
  const [applied, setApplied] = useState(() => ({
    filter: buildFilter({ range: DEFAULT_RANGE }),
    range: DEFAULT_RANGE,
  }));

  return (
    <Container>
      <div className="mt-4"></div>

      {/* One filter row above everything it scopes. Both aggregates below
          re-render against this slice and neither has a filter of its own.

          It produces a range and an event type, and no dimension at all: orgId
          is forced by the server and rejected if sent, and domainId is grouped
          by rather than filtered on. */}
      <Row>
        <Col>
          <Filter onApply={setApplied} />
        </Col>
      </Row>

      <Row>
        <Col>
          <Suspense fallback={<Loading.Content />}>
            <OrganizationCharts
              filter={applied.filter}
              range={applied.range}
              rangeLabel={rangeLabel(applied.range)}
            />
          </Suspense>
        </Col>
      </Row>
    </Container>
  );
};
